import React from 'react';
import styles from '../LandingPage.module.css';

const MarqueeStrip = () => {
  const items = [
    'INTELLIGENCE', 'AI-DRIVEN GCCS', 'SERVICENOW', 'SALESFORCE',
    'GENERATIVE AI', 'PROHIREY', 'TOXBOX AI', 'CLOUD & DEVOPS', 'QE & AUTOMATION'
  ];

  return (
    <div className={styles.marqueeContainer}>
      <div className={styles.marqueeTrack}>
        {/* Repeat twice for seamless scrolling if we want, or just static */}
        {items.map((item, index) => (
          <React.Fragment key={index}>
            <span className={styles.marqueeItem}>{item}</span>
            <span className={styles.marqueeDot}>•</span>
          </React.Fragment>
        ))}
        {items.map((item, index) => (
          <React.Fragment key={`copy-${index}`}>
            <span className={styles.marqueeItem}>{item}</span>
            <span className={styles.marqueeDot}>•</span>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default MarqueeStrip;
